import script from "./leftMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./leftMenu.vue?vue&type=script&setup=true&lang=js"

import "./leftMenu.vue?vue&type=style&index=0&id=6bbbb7ed&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bbbb7ed"]])

export default __exports__